<template>
  <div>
    <b-row>
      <b-col>
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <div class="m-1">
              <span class="pull-left" v-b-toggle="'collapse-'+question.id" style="cursor: pointer;"><strong>Vraag {{count+1}}: </strong>{{question.title}}</span>
              <span class="pull-right ml-2" @click="moveQuestionUp()" v-if="this.count > 0 && question.editable" style="cursor: pointer;"><i class="icon-arrow-up icons d-block"></i></span>
              <span class="pull-right" @click="moveQuestionDown()" style="cursor: pointer;" v-if="question.editable"><i class="icon-arrow-down icons d-block"></i></span>
            </div>
          </b-card-header>
          <b-collapse :id="'collapse-'+question.id" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-row>
                <b-col>
                  <b-form-group label="Titel">
                    <b-form-input type="text" required v-model="question.title" readonly></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Type vraag">
                    <b-form-select :options="questionTypes" type="text" required v-model="question.type" :disabled="true"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Vraag">
                    <b-form-input type="text" required v-model="question.question" readonly></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Zichtbaar">
                    <b-form-checkbox
                        required
                        v-model="question.visible"
                        switch
                        size="md"
                        value="1"
                        unchecked-value="0"
                        :disabled="true"
                    >
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <hr v-if="question.editable || question.deletable">
                  <b-button v-b-modal="'delete-' + question.id" class="btn btn-danger pull-left" size="sm" v-if="question.editable">Verwijder</b-button>
                  <b-button v-b-modal="'edit-'+question.id" class="btn btn-success pull-right" size="sm" v-if="question.deletable">Bewerk</b-button>
                </b-col>
              </b-row>
            </b-card-body>
          </b-collapse>
        </b-card>
      </b-col>
    </b-row>
    <b-modal :id="'delete-' + question.id" title="Verwijder vraag" hide-footer>
      <p>Weet je zeker dat je de vraag <strong>"{{question.title}}"</strong> wilt verwijderen?</p>
      <hr>
      <button @click="deleteQuestion()" class="btn btn-danger pull-right">Ja, verwijder vraag</button>
    </b-modal>
    <b-modal :id="'edit-'+question.id" title="Bewerk vraag" hide-footer>
      <b-form @submit.prevent="saveQuestion">
        <b-row>
          <b-col>
            <b-form-group label="Titel">
              <b-form-input type="text" required v-model="question.title"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Type vraag">
              <b-form-select :options="questionTypes" type="text" required v-model="question.type"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Vraag">
              <b-textarea required v-model="question.question" rows="3"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Zichtbaar">
              <b-form-checkbox
                  required
                  v-model="question.visible"
                  switch
                  value="1"
                  unchecked-value="0"
                  size="md"
              >
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="question.type === 'select'">
          <b-col>
            <b-form-group label="Antwoorden">
              <table class="table table-bordered">
                <tr v-for="(answer, index) in question.answers">
                  <td>
                    <b-form-input type="text" v-model="question.answers[index].text" required></b-form-input>
                  </td>
                  <td>
                    <i class="icon-close icons mt-2 h5 d-inline-block text-danger" style="cursor: pointer;" @click="question.answers.splice(index,1)"></i>
                  </td>
                </tr>
              </table>
              <span class="text-success pull-right" @click="addAnswer()" style="cursor: pointer;">Antwoord toevoegen <i class="icon-plus icons mt-3 d-inline-block"></i></span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <hr>
            <button type="submit" class="btn btn-success pull-right">Opslaan</button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
  import {getData, deleteItem, updateData} from '../../../api';

  export default {
    props: {
      question: {
        type: Object,
        required: true,
      },
      count: {
        required: true,
      },
    },
    data() {
      return {
        questionTypes: [
          {
            text: 'Postcode',
            value: 'postal-code'
          },
          {
            text: 'Open',
            value: 'open'
          },
          {
            text: 'E-mail',
            value: 'email'
          },
          {
            text: 'Smiley',
            value: 'smiley'
          },
          {
            text: 'Meerkeuzevraag',
            value: 'select'
          },
          {
            text: 'Schaal (1-5)',
            value: 'scale'
          },
          {
            text: 'QR',
            value: 'qr'
          },
          {
            text: 'Extra vraag',
            value: 'extra_question'
          }
        ],
      };
    },
    methods: {
      async saveQuestion() {
        const request = await updateData('questions/'+this.question.id, {
          question: this.question.question,
          type: this.question.type,
          title: this.question.title,
          visible: this.question.visible,
          answers: this.question.answers
        });
        if (request.status === 200) {
          this.$bvModal.hide('edit-'+this.question.id);
          this.$emit('refresh');
        }
      },
      addAnswer() {
        this.question.answers.push({
          text: '',
          value:''
        })
      },
      async deleteQuestion() {
        await deleteItem('questions/'+this.question.id).then(
          (response) => response.data
        );
        this.$bvModal.hide('delete-' + this.question.id);
        this.$emit('refresh')
      },
      async moveQuestionUp() {
        await getData('questions/'+this.question.id+'/move-up').then(
          (response) => response.data
        );
        this.$emit('refresh')
      },
      async moveQuestionDown() {
        await getData('questions/'+this.question.id+'/move-down').then(
          (response) => response.data
        );
        this.$emit('refresh')
      }
    },
    computed: {
      userRole () {
        return this.$store.state.userRole
      }
    },
  }
</script>
